import { Component, Input } from '@angular/core';
import { DropdownMenuData } from '@ridango/core';

@Component({
    selector: 'gl-dropdown-menu',
    templateUrl: './dropdown-menu.component.html',
    styleUrls: ['./dropdown-menu.component.scss']
})
export class DropdownMenuComponent {
    @Input() menuData: DropdownMenuData | null = null;
    @Input() config: { width: number };
}
